"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersV1 = void 0;
const api_1 = require("./api");
const usersV1 = (caller) => (0, api_1.userV1Api)(caller);
exports.usersV1 = usersV1;
//# sourceMappingURL=index.js.map